import React from "react";

import { Switch } from "@mui/material";

const FormSwitch = React.forwardRef(({ ariaLabel, ariaLabelledBy, inputProps = {}, ...props }, ref) => {
  const mergedInputProps = {
    ...(ariaLabel ? { "aria-label": ariaLabel } : {}),
    ...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy } : {}),
    ...inputProps,
  };
  return <Switch ref={ref} className="form-switch" inputProps={mergedInputProps} {...props} />;
});

export default FormSwitch;
